import { LanguageType } from "~/types/language/language.types";

export const getLanguage = <T>(elt: T, key: string, language: LanguageType) =>
  elt[`${key}${language}` as keyof T];
